import React, { useState, useEffect } from "react";
import { Container, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Input, Col } from 'reactstrap';
import { Formik, Form, FieldArray } from "formik";
import { Loading } from '../../share/loading'
import * as Yup from 'yup'
import '../../share/form.css';
import Swal from 'sweetalert2'
import * as XLSX from "xlsx";
import '../../SupportSystem/Reports/reportall.css';
import { NumberWithCommmas2 } from "../../share/NumberWithCommmas2";

export function NewReportAllocatedAndSubsidies42Component() {
  const [data, setData] = useState([]);
  const [selectSupport, setSelectSupport] = useState([]);
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("userData"));
  const [openModal, setOpenModal] = useState(false);
  const ToggleModal = () => setOpenModal(!openModal);

  useEffect(() => {
    getdatafromview();
  }, []);

  async function getdatafromview() {
    setLoading(true);
    try {
      let res = await fetch("/api/SupportAllowcate/listAllocated42", {
        method: "POST",
        headers: { 'token': user.token },
      });
      const d = await res.json();
      setData(d.dataenum || []);
      setSelectSupport(
        (d.dataenum || []).filter((v, i, arr) => arr.findIndex(v2 => (v2.supportId === v.supportId)) === i)
      );
    } catch (e) {
      console.log("err =>" + e);
    } finally {
      setLoading(false);
    }
  }

  // จัดกลุ่มสำหรับ rowSpan
  const groupBySupport = (rows) => {
    const map = new Map();
    const order = [];
    rows?.forEach(r => {
      if (!map.has(r.supportId)) {
        map.set(r.supportId, []);
        order.push(r.supportId);
      }
      map.get(r.supportId).push(r);
    });
    return order.map((key, idx) => ({
      supportId: key,
      seq: idx + 1,
      rows: map.get(key),
      rowspan: map.get(key).length
    }));
  };
  const groups = groupBySupport(data);

  // ---------- Export XLSX (merge เฉพาะ 5 คอลัมน์ที่ระบุ) ----------
  const exportXlsxMerged = async (selectedSupportIds) => {
    const dataSelected = data.filter(d => selectedSupportIds.includes(d.supportId));
    const groupsSelected = groupBySupport(dataSelected);

    // หัวตาราง 3 แถว (ให้ตรงกับ thead)
    const h1 = [
      "ที่","เลขที่คำขอ","วันที่รับคำขอ","ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน",
      "เงินสมทบที่นำส่ง","", "ประกาศข้อ 5","",
      "จำนวนเงินที่ขอรับ(บาท)","จำนวนเงินที่อนุมัติ(บาท)"
    ];
    const h2 = [
      "","","","",
      "วัน/เดือน/ปี ที่นำส่ง","จำนวนเงิน(บาท)",
      "ลูกจ้างเฉลี่ย(คน)","จำนวนลูกจ้างที่ได้รับการพัฒนา(คน)",
      "",""
    ];
    const h3 = ["","","","","","","","","",""];
    const aoa = [h1, h2, h3];

    const COL = {
      SEQ: 0,
      SUPPORT_NO: 1,
      PAYMENT_DATE: 2,
      SUPPORT_NAME: 3,
      RECEIPT_DATE: 4,
      CONTRIBUTION_AMOUNT: 5,
      AVG_MAN: 6,
      TRAINED_MAN: 7,
      REQ_AMOUNT: 8,
      APPROVED_AMOUNT: 9
    };

    // เติมข้อมูล: เขียนค่าจริงทุกแถวสำหรับคอลัมน์ที่ "ไม่ merge"
    groupsSelected.forEach(g => {
      g.rows.forEach((r, idx) => {
        aoa.push([
          idx === 0 ? g.seq : "",                           // ลำดับ (merge)
          idx === 0 ? (r.supportNo ?? "-") : "",            // เลขที่คำขอ (merge)
          idx === 0 ? (r.paymentDate ?? "-") : "",          // วันที่รับคำขอ (merge)
          idx === 0 ? (r.supportName ?? "-") : "",          // ชื่อผู้ขอ (merge)
          r.receiptDate ?? "-",                             // วัน/เดือน/ปี ที่นำส่ง (ไม่ merge)
          r.amount != null ? Number(r.amount) : "",         // จำนวนเงิน(บาท) เงินสมทบ (ไม่ merge)
          r.avgMan ?? "",                                   // ลูกจ้างเฉลี่ย (ไม่ merge)
          r.spktrainMan ?? "",                              // ลูกจ้างที่ได้รับการพัฒนา (ไม่ merge)
          idx === 0 ? (r.paymentAmount ?? "") : "",         // ขอรับ (merge)
          idx === 0 ? (r.paymentAmount ?? "") : ""          // อนุมัติ (merge)
        ]);
      });
    });

    const ws = XLSX.utils.aoa_to_sheet(aoa);

    ws['!cols'] = [
      { wch: 5 }, { wch: 16 }, { wch: 14 }, { wch: 42 },
      { wch: 16 }, { wch: 18 }, { wch: 14 }, { wch: 24 },
      { wch: 20 }, { wch: 20 },
    ];

    // Merge หัวตาราง (เหมือนเดิม)
    const merges = [
      { s: { r: 0, c: COL.SEQ }, e: { r: 2, c: COL.SEQ } },
      { s: { r: 0, c: COL.SUPPORT_NO }, e: { r: 2, c: COL.SUPPORT_NO } },
      { s: { r: 0, c: COL.PAYMENT_DATE }, e: { r: 2, c: COL.PAYMENT_DATE } },
      { s: { r: 0, c: COL.SUPPORT_NAME }, e: { r: 2, c: COL.SUPPORT_NAME } },
      { s: { r: 0, c: COL.REQ_AMOUNT }, e: { r: 2, c: COL.REQ_AMOUNT } },
      { s: { r: 0, c: COL.APPROVED_AMOUNT }, e: { r: 2, c: COL.APPROVED_AMOUNT } },
      { s: { r: 0, c: COL.RECEIPT_DATE }, e: { r: 0, c: COL.CONTRIBUTION_AMOUNT } },
      { s: { r: 0, c: COL.AVG_MAN }, e: { r: 0, c: COL.TRAINED_MAN } },
    ];

    // Merge ตัวข้อมูล (แนวตั้ง) เฉพาะ 5 คอลัมน์ที่คุณขอ (และลำดับ)
    const headerRows = 3;
    let current = headerRows;
    groupsSelected.forEach(g => {
      const start = current;
      const end = current + g.rowspan - 1;
      if (g.rowspan > 1) {
        [COL.SEQ, COL.SUPPORT_NO, COL.PAYMENT_DATE, COL.SUPPORT_NAME, COL.REQ_AMOUNT, COL.APPROVED_AMOUNT]
          .forEach(c => merges.push({ s: { r: start, c }, e: { r: end, c } }));
      }
      current = end + 1;
    });

    ws['!merges'] = merges;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "รายงาน");
    XLSX.writeFile(wb, "แบบขอรับการจัดสรรเงินช่วยเหลือ_ข้อ5.xlsx");
  };

  const ExportSupport = async (values) => {
    const picked = (values?.selectExportAr || []).filter(v => v.status);
    if (!picked.length) {
      await Swal.fire({
        icon: "error",
        title: "กรุณาเลือกอย่างน้อย 1 รายการ",
        confirmButtonColor: "#0A66C2",
        confirmButtonText: "ตกลง",
      });
      return;
    }
    const selectedIds = picked.map(x => x.supportId);

    setLoading(true);
    try {
      await exportXlsxMerged(selectedIds);

      // อัปเดตสถานะหลังบ้าน (ตัวอย่างใช้ FormData ตามที่คุณมีอยู่)
      const formData = new FormData();
      Array.from(new Set(selectedIds)).forEach(id => formData.append("supportIds", id));
      const updateRes = await fetch("/api/SupportAllowCate/updateStatusSupportAllocate", {
        method: "POST",
        body: formData
      });
      if (!updateRes.ok) throw new Error("อัปเดตสถานะไม่สำเร็จ");

      await Swal.fire({
        icon: "success",
        title: "ส่งออกสำเร็จ",
        text: "ได้ทำการอัปเดตสถานะเรียบร้อยแล้ว",
        confirmButtonColor: "#0A66C2",
        confirmButtonText: "ตกลง",
      });

      ToggleModal();
      await getdatafromview();
    } catch (e) {
      console.log(e);
      Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาดในการส่งออกไฟล์" });
    } finally {
      setLoading(false);
    }
  };

  const initialValues = {
    selectExportAr: selectSupport.map((item) => ({
      supportId: item?.supportId,
      status: false,
    })),
  };
  const validateSchema = Yup.object().shape({});

  if (loading) return <Loading />;

  return (
    <Container>
      <center>
        <Label>
          แบบขอรับการจัดสรรเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน ประจำปีงบประมาณ พ.ศ.
          {data?.length > 0 ? data[0]?.budgetYear : null}
        </Label>
      </center>
      <center><Label>ตามประกาศคณะกรรมการส่งเสริมการพัฒนาฝีมือแรงงาน</Label></center>
      <center>
        <Label>เรื่อง หลักเกณฑ์การใช้จ่ายเงินเพื่อช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน ลงวันที่ 31 มีนาคม พ.ศ. 2568</Label>
      </center>

      <div className="d-flex w-100 align-items-center justify-content-end mb-3">
        <button
          onClick={ToggleModal}
          disabled={!selectSupport.length}
          className="btn-green p-2 w-25"
        >
          Export Excel
        </button>
      </div>

      <div className="outer-wrapper">
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th rowSpan="3">ที่</th>
                <th rowSpan="3">เลขที่คำขอ</th>
                <th rowSpan="3">วันที่รับคำขอ</th>
                <th rowSpan="3">ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน</th>
                <th colSpan="4">ประกาศข้อ 5</th>
                <th rowSpan="3">จำนวนเงินที่ขอรับ<br />(บาท)</th>
                <th rowSpan="3">จำนวนเงินที่อนุมัติ<br />(บาท)</th>
              </tr>
              <tr>
                <th colSpan="2">เงินสมทบที่นำส่ง</th>
                <th colSpan="2">ดำเนินการพัฒนาฝีมือแรงงาน </th>
              </tr>
              <tr>
                <th>วัน/เดือน/ปี ที่นำส่ง</th>
                <th>จำนวนเงิน<br />(บาท)</th>
                <th>ลูกจ้างเฉลี่ย<br />(คน)</th>
                <th>จำนวนลูกจ้างที่ได้รับการพัฒนา<br />(คน)</th>
              </tr>
            </thead>

            <tbody>
              {groups?.length ? (
                groups.map(g =>
                  g.rows.map((item, idx) => (
                    <tr key={`${g.supportId}-${idx}`}>
                      {/* ลำดับ (ยัง merge เพื่อความอ่านง่าย) */}
                      {idx === 0 && <td rowSpan={g.rowspan} className="text-center">{g.seq}</td>}

                      {/* 1) เลขที่คำขอ (merge) */}
                      {idx === 0
                        ? <td rowSpan={g.rowspan} className="text-end">{item.supportNo ?? "-"}</td>
                        : null}

                      {/* 2) วันที่รับคำขอ (merge) */}
                      {idx === 0
                        ? <td rowSpan={g.rowspan} className="text-center">{item.paymentDate ?? "-"}</td>
                        : null}

                      {/* 3) ชื่อผู้ขอรับเงิน (merge) */}
                      {idx === 0
                        ? <td rowSpan={g.rowspan} className="text-left">{item.supportName ?? "-"}</td>
                        : null}

                      {/* คอลัมน์ในกลุ่ม "ประกาศข้อ 5" ที่ไม่ต้อง merge: แสดงทุกแถว */}
                      <td className="text-center">{item.receiptDate ?? "-"}</td>
                      <td className="text-center">
                        {item.amount != null ? NumberWithCommmas2(item.amount) : "-"}
                      </td>
                      <td className="text-end">{item.avgMan ?? "-"}</td>
                      <td className="text-end">{item.spktrainMan ?? "-"}</td>

                      {/* 4) จำนวนเงินที่ขอรับ (merge) */}
                      {idx === 0
                        ? <td rowSpan={g.rowspan} className="text-end">
                            {item.paymentAmount != null ? NumberWithCommmas2(item.paymentAmount) : "-"}
                          </td>
                        : null}

                      {/* 5) จำนวนเงินที่อนุมัติ (merge) */}
                      {idx === 0
                        ? <td rowSpan={g.rowspan} className="text-end">
                            {item.paymentAmount != null ? NumberWithCommmas2(item.paymentAmount) : "-"}
                          </td>
                        : null}
                    </tr>
                  ))
                )
              ) : (
                <tr><td className="text-center" colSpan="10">ไม่มีข้อมูล</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Modal
        isOpen={openModal}
        toggle={ToggleModal}
        backdrop={'static'}
        keyboard={false}
        size="l"
        className="modal-bordered"
        centered
      >
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validateSchema}
          onSubmit={ExportSupport}
        >
          {({ values, handleChange, handleBlur, setFieldValue, handleSubmit }) => {
            const PreExport = () => {
              const pass = values.selectExportAr.some(el => el.status === true);
              if (!pass) {
                Swal.fire({
                  icon: "error",
                  title: "กรุณาเลือกอย่างน้อย 1 รายการ",
                  confirmButtonColor: "#0A66C2",
                  confirmButtonText: "ตกลง",
                });
              } else {
                Swal.fire({
                  icon: "info",
                  title: "ยืนยันการทำรายการหรือไม่ ?",
                  html: "หากยืนยันการทำรายการแล้ว <br/>จะไม่สามารถเลือกผู้ขอรับเงินช่วยเหลือหรืออุดหนุนเดิมได้",
                  confirmButtonColor: "#0A66C2",
                  confirmButtonText: "ตกลง",
                  showCancelButton: true,
                  cancelButtonText: "ยกเลิก",
                  cancelButtonColor: "#ff0000",
                }).then((result) => {
                  if (result.isConfirmed) handleSubmit(values);
                });
              }
            };

            return (
              <Form>
                <ModalHeader toggle={ToggleModal}>เลือกชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน</ModalHeader>
                <ModalBody>
                  <FieldArray name="selectExportAr">
                    {() => (
                      <div className="d-flex flex-column mt-3">
                        {selectSupport?.map((support, index) => (
                          <FormGroup row key={support.supportId ?? index}>
                            <Col>
                              <Label>
                                <Input
                                  type="checkbox"
                                  className="cus-type"
                                  name={`selectExportAr[${index}].status`}
                                  onBlur={handleBlur}
                                  onChange={(e) => {
                                    handleChange(e);
                                    setFieldValue(e.target.name, e.target.checked);
                                  }}
                                />
                              </Label>
                              <span className="ms-3">{support.supportName}</span>
                            </Col>
                          </FormGroup>
                        ))}
                      </div>
                    )}
                  </FieldArray>
                </ModalBody>
                <ModalFooter className="d-flex justify-content-center align-items-center">
                  <button
                    disabled={!selectSupport.length}
                    type="button"
                    onClick={PreExport}
                    className="btn-green p-2 w-25"
                  >
                    Export
                  </button>
                </ModalFooter>
              </Form>
            );
          }}
        </Formik>
      </Modal>
    </Container>
  );
}

// const validateSchema = Yup.object().shape({});
